import axios from "./axios";

export default async function (user: string, password: string, lang: string) {
    return await axios.post("user/login", {
        lang,
        user,
        password,
        type: "member_no",
        push_os: "web",
        //recaptcha_token: await window.grecaptcha.execute('6LdoWDIpAAAAAEaCpBaxQj_fm81y7SjBAZeAd_7f', { action: 'submit' })
        //recaptcha_token
    });
}